import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import ProductSuggestionsTable from 'components/tables/ProductSuggestionsTable/ProductSuggestionsTable';
import useGlobalStyles from 'styles/globalStyles';


export default function DeletedProductSuggestionsPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Deleted Suggestions'}
            buttons={[]}
          />
        </Box>

        <Box mt={3}>
          <ProductSuggestionsTable deletedView />
        </Box>
      </Container>

    </Box>
  )
}
